import React from 'react';
import Select from 'react-select';

export default function DynamicVaccineNurse(props) {
  const {
    vaccineTypes,
    dynamic_vaccine,
    isHistory,
    vaccine_id,
    vaccine_selected,
    period,
    vaccineChangeHandler,
    vaccineRemoveHandler,
  } = props;
  return (
    <span style={{ padding: '.5rem 0' }}>
      <br />
      <Select
        style={{ width: '1rem' }}
        // isMulti
        isDisabled={isHistory}
        // components={{ Placeholder }}
        placeholder={'Pilih Jenis Vaksin'}
        // styles={{
        // placeholder: base => ({
        //     ...base,
        //     // fontSize: '1em',
        //     color: 'black',
        //     // fontWeight: 400,
        // }),
        // }}
        options={vaccineTypes}
        value={vaccine_selected}
        onChange={(value) => {
          vaccineChangeHandler(vaccine_id, value, period);
        }}
        required
      />
      {/* </span> */}
      {/* <br /> */}
      {isHistory && <br />}
      <span style={{ display: 'flex', justifyContent: 'space-between' }}>
        <input
          style={{
            width: dynamic_vaccine.length < 2 || isHistory ? '100%' : '70%',
            border: '1.3px solid rgb(36, 177, 253)',
            padding: '.5rem',
            borderRadius: '4px',
            margin: '0px',
            height: '3rem',
            background: '#CCC',
            cursor: 'not-allowed',
          }}
          type="text"
          name="period"
          placeholder="Masukkan Periode (Dengan angka)"
          value={period || ''}
          disabled
          onChange={(e) => {
            vaccineChangeHandler(vaccine_id, vaccine_selected, e.target.value);
          }}
          className="add-vaccine-input"
          required
        />

        {dynamic_vaccine.length > 1 && !isHistory && (
          <button
            className="btn btn-danger mr-1"
            onClick={() => {
              vaccineRemoveHandler(vaccine_id);
            }}
          >
            Hapus Data
          </button>
        )}
      </span>
      <hr />
    </span>
  );
}
